module.exports = "<p class=\"info\">\n  {{t.note}}\n</p>\n"